export default {
  data () {
    return {
      errors: null
    }
  },

  methods: {
    errorMessage (key) {
      if (this.errors && this.errors[key]) {
        const [errorCode, limit] = this.errors[key]
        let errorMessage = this.$t(`server_error_codes.${errorCode}`)
        if (limit !== undefined && errorMessage.includes('{limit}')) {
          errorMessage = errorMessage.replace('{limit}', limit)
        }
        return errorMessage
      }
      return null
    },
    clearError (field) {
      this.$set(this.errors, field, null)
    }
  }
}
